import { useEffect, useState, useCallback } from "react";
import { Trash2, Mail, Phone, Calendar, Check, Archive } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const statusMap = {
  new: { label: "Nouveau", cls: "bg-emerald-500/15 text-emerald-300" },
  contacted: { label: "Contacté", cls: "bg-amber-500/15 text-amber-300" },
  archived: { label: "Archivé", cls: "bg-slate-600/30 text-slate-400" },
};

export const ReservationsManager = () => {
  const [list, setList] = useState([]);
  const load = useCallback(() => api.get("/admin/reservations").then(({ data }) => setList(data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);

  const setStatus = async (id, status) => {
    await api.patch(`/admin/reservations/${id}`, { status });
    load();
  };
  const remove = async (id) => {
    if (!window.confirm("Supprimer cette demande ?")) return;
    await api.delete(`/admin/reservations/${id}`);
    toast.success("Demande supprimée");
    load();
  };

  return (
    <div data-testid="admin-reservations-manager">
      <h1 className="font-serif text-3xl text-amber-50 mb-2">Demandes &amp; Contacts</h1>
      <p className="text-slate-400 mb-8">Messages et demandes de consultation reçus.</p>

      {list.length === 0 ? (
        <p className="text-slate-500">Aucune demande pour le moment.</p>
      ) : (
        <div className="space-y-4">
          {list.map((r) => {
            const st = statusMap[r.status] || statusMap.new;
            return (
              <div key={r.id} className="glass rounded-2xl p-6" data-testid={`reservation-row-${r.id}`}>
                <div className="flex items-start justify-between gap-4 flex-wrap">
                  <div className="flex-1 min-w-[200px]">
                    <div className="flex items-center gap-3 mb-2 flex-wrap">
                      <span className="font-serif text-lg text-amber-100">{r.name}</span>
                      <span className={`text-xs px-2 py-0.5 rounded-full ${st.cls}`}>{st.label}</span>
                      <span className="text-xs px-2 py-0.5 rounded-full bg-white/5 text-slate-400">{r.type === "reservation" ? "Consultation" : "Contact"}</span>
                    </div>
                    <div className="flex flex-wrap gap-4 text-sm text-slate-400 mb-3">
                      <span className="inline-flex items-center gap-1"><Mail size={13} /> {r.email}</span>
                      {r.phone && <span className="inline-flex items-center gap-1"><Phone size={13} /> {r.phone}</span>}
                      {r.slot && <span className="inline-flex items-center gap-1"><Calendar size={13} /> {r.slot}</span>}
                    </div>
                    <p className="text-slate-300 text-sm">{r.message}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <button onClick={() => setStatus(r.id, "contacted")} data-testid={`reservation-contacted-${r.id}`} className="p-2 rounded-lg hover:bg-amber-500/10 text-amber-300" title="Marquer contacté"><Check size={16} /></button>
                    <button onClick={() => setStatus(r.id, "archived")} data-testid={`reservation-archive-${r.id}`} className="p-2 rounded-lg hover:bg-white/5 text-slate-400" title="Archiver"><Archive size={16} /></button>
                    <button onClick={() => remove(r.id)} data-testid={`reservation-delete-${r.id}`} className="p-2 rounded-lg hover:bg-red-500/10 text-red-400"><Trash2 size={16} /></button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
